import React, { useEffect, useRef, useState } from "react";
import topSvg from "../../../assets/svg/top.svg";
import bottomSvg from "../../../assets/svg/bottom.svg";
import mainLogoSvg from "../../../assets/img/Main logo.png";
import { Form, Input, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import svg41 from "../../../assets/svg/svg41.svg";
import svgone from "../../../assets/svg/svgone.svg";
import ReactPasswordChecklist from "react-password-checklist";
import {
  cleanForgotAcc,
  cleanSingleUser,
  save,
} from "../../../features/auth/authSlice";
import ConfirmModal from "../../../components/ConfirmModal";

function ForgotPassword() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formRef = useRef(null);

  const { authLoading, forgotAcc } = useSelector((state) => state.auth);

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = async () => {
    await setOpenDelete(false);
    await navigate("/login");
  };
  const handleDelete = async () => {
    await setOpenDelete(false);
    await navigate("/login");
  };

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const onFinish = async (data) => {
    const isPasswordValid =
      password.length >= 8 &&
      /\d/.test(password) &&
      /[A-Z]/.test(password) &&
      /[!@#$%^&*()_+[\]{};':"\\|,.<>/?]+/.test(password) &&
      password === confirmPassword;
    if (!isPasswordValid) {
      toast.error(
        "Password does not meet the required conditions or does not match"
      );
      return;
    }

    const res = await dispatch(
      save({
        usrId: forgotAcc?.usrId,
        usrSecret: password,
        url: "auth/update-password",
      })
    );
    if (res?.payload?.success) {
      toast.success(res.payload?.message);
      await form.resetFields();
      await dispatch(cleanForgotAcc());
      await dispatch(cleanSingleUser());
      await handleOpenDelete();
    } else {
      toast.error(res.payload?.message);
    }
  };

  const handleCancel = async () => {
    await navigate("/login");
  };

  return (
    <div className="w-full h-full min-h-screen flex flex-col op-bg">
      <div>
        <img src={topSvg} alt="topSvg" />
      </div>
      <div className="w-full flex flex-col h-full lg:px-0 px-3 lg:items-center lg:justify-center ">
        <div className="login-card lg:p-[2.5rem] p-3">
          <div>
            <img
              src={mainLogoSvg}
              alt="mainLogoSvg"
              className="cursor-pointer"
              onClick={() => navigate("/")}
            />
          </div>
          <div className="typography_1 mt-[2.5rem]">Set your new password</div>
          <div className="typography_2">
            Set a strong and secure password that you can remember
          </div>
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className="lg:w-[34.25rem] w-full"
            style={{
              maxWidth: "100%",
              marginTop: "2.06rem",
            }}
            form={form}
          >
            <Form.Item
              label="Password"
              name="usrEncryptedPassword"
              rules={[
                {
                  required: true,
                  message: "Please input your password",
                },
              ]}
            >
              <Input.Password
                onChange={(e) => setPassword(e.target.value)}
                className="input"
                type="password"
              />
            </Form.Item>

            <Form.Item
              label="Confrim password"
              name="usrEncryptedPasswordAlt"
              rules={[
                {
                  required: true,
                  message: "Please input your password",
                },
              ]}
            >
              <Input.Password
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="input"
                type="password"
              />
            </Form.Item>

            <span>
              To protect your account, we require that your password has;
            </span>

            <div className="mt-[.32rem]">
              <ReactPasswordChecklist
                className="text-darkBlue"
                rules={[
                  "minLength",
                  "specialChar",
                  "number",
                  "capital",
                  "match",
                ]}
                minLength={8}
                value={password}
                valueAgain={confirmPassword}
                messages={{
                  minLength: "A minimum of 8 characters",
                  number: "At least one number (0-9)",
                  capital: "At least one upper case letter (A-Z)",
                  match: "Confirm password to match with the password",
                  specialChar:
                    "At least one special character e.g !@#$%^&*()_+{}[]:;?/|\\",
                }}
                iconComponents={{
                  ValidIcon: (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="w-6 h-6 text-darkBlue"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  ),
                  InvalidIcon: (
                    <img className="pr-[.5rem]" src={svgone} alt="lazy" />
                  ),
                }}
                validColor="#147CBC"
                iconSize={2}
              />
            </div>

            <div className="flex justify-center w-full mt-[1rem]">
              <button
                className="cstm-btn-2"
                type="submit"
                disabled={authLoading ? true : false}
              >
                {authLoading ? <Spin /> : "Save New Password"}
              </button>
            </div>

            <div className="flex justify-between mt-[1rem]">
              <div
                className="flex items-center gap-x-[1rem] cursor-pointer"
                onClick={handleCancel}
              >
                <img src={svg41} alt="svg41" />
                <span className="back">Back to login</span>
              </div>
              <Link className="forgot-text !text-[#0092CC]">Help</Link>
            </div>
          </Form>
        </div>
      </div>
      <div className="w-full  mt-auto flex items-center justify-center bottom-0">
        <img src={bottomSvg} alt="bottomSvg" />
      </div>

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={authLoading}
        content="Your new password has been set"
        btnTitle="Go to Login"
      />
    </div>
  );
}

export default ForgotPassword;
